import { createContext, useContext, useState } from "react"
import { DialogProcessoSetor } from "../../../../views/components/dialog/dialog-processo-setor/dialog-processo-setor";
import { DialogConfigGerais } from "../../../../views/components/dialog/dialog-config-gerais/dialog-config-gerais";
import { EnumCodigosPermissoes } from "../../../../model/enums/enum-codigos-permissoes";
import { EnumTpPermissaoUsuario } from "../../../../model/enums/enum-tp-permissao-usuario";
import { useToastSaurus } from "../../use-cases";
import { DialogSolicitarPermissao, DialogSolicitarPermissaoProps } from "../../../../views/components/dialog/dialog-solicitar-permissao/dialog-solicitar-permissao";
import { useSessaoAtual } from "../..";
import { DialogAssumirEntrega, DialogAssumirEntregaProps } from "../../../../views/components/dialog/dialog-assumir-entrega/dialog-assumir-entrega";
import { DialogPermissaoLocalizacao } from "../../../../views/components/dialog/dialog-permissao-localizacao/dialog-permissao-localizacao";

interface DialogContextValues {
   //dialog de setores
   fecharSetores: () => void,
   abrirSetores: () => void,

   //dialog de configurações gerais
   fecharConfigGerais: () => void,
   abrirConfigGerais: () => void

   //dialog de solicitação de permissão
   fecharSolicitarPermissao: () => void,
   abrirSolicitarPermissao: (props: DialogSolicitarPermissaoProps) => void,

   //dialog de assumir entrega
   fecharAssumirEntrega: () => void,
   abrirAssumirEntrega: (props: DialogAssumirEntregaProps) => void,

   //dialog de permissão de localização
   fecharPermissaoLocalizacao: () => void,
   abrirPermissaoLocalizacao: () => void,
}


const DialogContext = createContext<DialogContextValues>({
   fecharSetores: () => true,
   abrirSetores: () => true,
   fecharConfigGerais: () => true,
   abrirConfigGerais: () => true,
   abrirSolicitarPermissao: (props: DialogSolicitarPermissaoProps) => true,
   fecharSolicitarPermissao: () => true,
   fecharAssumirEntrega: () => true,
   abrirAssumirEntrega: (props: DialogAssumirEntregaProps) => true,
   fecharPermissaoLocalizacao: () => true,
   abrirPermissaoLocalizacao: () => true,
})
export interface DialogProviderProps {
   children: React.ReactNode;
}


export const useDialog = () => useContext(DialogContext)
export const DialogProvider = ({ children }: DialogProviderProps) => {
   const { showToast } = useToastSaurus()
   const { getPermissaoBoolean } = useSessaoAtual()

   const [openSetores, setOpenSetores] = useState(false)
   const [openConfigGerais, setOpenConfigGerais] = useState(false)
   const [openSolicitarPermissao, setOpenSolicitarPermissao] = useState<DialogSolicitarPermissaoProps>({
      openned: false,
      acao: () => Promise.resolve(),
      cod: EnumCodigosPermissoes.ACRESCIMO_ITEM,
      label: 'Solicitar permissão',
      tipoPermissao: EnumTpPermissaoUsuario.SimNao,
      valor: false,
      cancelAction: () => true,
   })

   const [openAssumirEntrega, setOpenAssumirEntrega] = useState<DialogAssumirEntregaProps>({
      aberto: false,
      onClickAssumir: () => Promise.resolve(),
   })

   const [openPermissaoLocalizacao, setOpenPermissaoLocalizacao] = useState(false)

   const abrirSetores = () => {
      if (!getPermissaoBoolean(EnumCodigosPermissoes.CONFIG_SETORES_PROCESSOS)) {
         abrirSolicitarPermissao({
            ...openSolicitarPermissao,
            cod: EnumCodigosPermissoes.CONFIG_SETORES_PROCESSOS,
            label: 'Solicitar permissão para configurar setores',
            tipoPermissao: EnumTpPermissaoUsuario.SimNao,
            valor: false,
            cancelAction: () => true,
            acao: async () => {
               setOpenSetores(true);
            }
         })
         return
      }
      setOpenSetores(true);
   }

   const fecharSetores = () => {
      setOpenSetores(false);
   }

   const abrirConfigGerais = () => {
      setOpenConfigGerais(true);
   }

   const fecharConfigGerais = () => {
      setOpenConfigGerais(false);
   }

   const abrirSolicitarPermissao = ({
      ...props
   }: DialogSolicitarPermissaoProps) => {

      if (navigator.onLine) {
         setOpenSolicitarPermissao({
            ...props,
            openned: true,
         });
         return
      }
      showToast(
         'info',
         `Você não possui permissão para realizar esta ação. Conecte-se à internet para solicitar permissão.`
      );
   }

   const fecharSolicitarPermissao = () => {
      setOpenSolicitarPermissao({
         ...openSolicitarPermissao,
         openned: false,
      });
   }

   const abrirAssumirEntrega = (props: DialogAssumirEntregaProps) => {
      setOpenAssumirEntrega({
         ...props,
         aberto: true,
      });
   }

   const fecharAssumirEntrega = () => {
      setOpenAssumirEntrega({
         ...openAssumirEntrega,
         aberto: false,
      });
   }

   const abrirPermissaoLocalizacao = () => {
      setOpenPermissaoLocalizacao(true);
   }

   const fecharPermissaoLocalizacao = () => {
      setOpenPermissaoLocalizacao(false);
   }

   return (
      <DialogContext.Provider value={{
         fecharSetores,
         abrirSetores,
         fecharConfigGerais,
         abrirConfigGerais,
         fecharSolicitarPermissao,
         abrirSolicitarPermissao,
         abrirAssumirEntrega,
         fecharAssumirEntrega,
         fecharPermissaoLocalizacao,
         abrirPermissaoLocalizacao,
      }}>
         <>
            {openSetores && (
               <DialogProcessoSetor openned={openSetores} />
            )}
            {openConfigGerais && (
               <DialogConfigGerais openned={openConfigGerais} />
            )}
            {openSolicitarPermissao.openned && (
               <DialogSolicitarPermissao {...openSolicitarPermissao} />
            )}
            {openAssumirEntrega.aberto && (
               <DialogAssumirEntrega {...openAssumirEntrega} />
            )}
            {openPermissaoLocalizacao && (
               <DialogPermissaoLocalizacao aberto={openPermissaoLocalizacao} />
            )}
            {children}
         </>
      </DialogContext.Provider>
   )

}